import { API_BASE_URL } from '../config';

/**
 * Universal media URL resolver.
 * Handles local uploads (/uploads/...), remote S3/CDN URLs, and ensures
 * correct paths in web, dev proxy, and Capacitor native iOS/Android builds.
 *
 * @param {string} url - Raw URL or relative path from API/database
 * @returns {string} Fully resolved, loadable URL
 */
export function getMediaUrl(url) {
  if (!url || typeof url !== 'string') return '';

  const trimmed = url.trim();
  if (!trimmed) return '';

  // Data URLs and Blobs (e.g. during local composer preview)
  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed;
  }

  // Absolute URLs (external or S3/CDN)
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  // Relative path (e.g. /uploads/images/xxx.jpg or uploads/images/xxx.jpg)
  const normalizedPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;

  // If in Capacitor / native environment with configured API_BASE_URL, prepend it
  if (API_BASE_URL) {
    const base = API_BASE_URL.replace(/\/+$/, '');
    return `${base}${normalizedPath}`;
  }

  return normalizedPath;
}

export default getMediaUrl;
